export enum UserRoles {
  SuperAdmin = "SuperAdmin",
  SuperAdminLight = "SuperAdminLight",
  Agent = "Agent",
}
